import React from 'react';
import 'whatwg-fetch'

class Instagram extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			data: null,
		};
	}

	async componentDidMount() {
		let response = await window.fetch("/load-instagram.php", {
		});

		let json = await response.json();
		await console.log(json);
		this.setState((prevState) => ({
			data: json.data.user.edge_owner_to_timeline_media.edges
		}))
	}

	render() {


		let data = this.state.data;
		let items = null;
		let lang = this.props.lang;

		if (data) {
			items = this.state.data.map((item, index) => {
				item = item.node
				if (index === 3) {
					return (
						<div className="item redirect">
							<p>{lang.FROM_OUR_INSTAGRAM}</p>
							<a href="https://www.instagram.com/brainy.sk/" target="_blank">{lang.GO_TO} <img
								src="/images/instagram.png" alt="" /> Instagram</a>
						</div>
					)
				} else {

					return (
						<a href={'https://www.instagram.com/brainy.sk/p/' + item.shortcode} className="item"
						   target="_blank">
							<img src={item.thumbnail_src} alt="" />
							<div className="overlay"></div>
						</a>
					)
				}
			})
		}
		return (
			<React.Fragment>
				<div className="items">
					{items}
				</div>
			</React.Fragment>
		);
	}
}


export default Instagram;
